export const EMAIL_VERIFICATION_KEY = 'emailStatus'
export const PHONE_VERIFICATION_KEY = 'phoneStatus'

export const VERIFICATION_STATUS = {
  VERIFIED: 'verified',
  NOT_VERIFIED: 'not_verified',
  FAILED: 'failed',
  VERIFIED_ENROLLED_MFA: 'verified_enrolled_mfa',
  NOT_VERIFIED_ENROLLED_MFA: 'not_verified_enrolled_mfa',
} as const

export const TWO_FA_STATUS = {
  BLOCKED_FROM_2FA: 'blocked_from_2fa',
  UNBLOCKED: 'unblocked',
  UNSPECIFIED: 'unspecified',
} as const

export const STATUS = {
  SUCCESS: 'success',
  PENDING: 'pending',
  FAILED: 'failed',
  INVALID: 'invalid',
} as const

export const BANK_CONNECTION_STATUS = {
  ACTIVE: 'active',
  NEAR_EXPIRY: 'near-expiry',
  REVOKED: 'revoked',
  INACTIVE: 'inactive',
  EXPIRED: 'expired',
  PENDING: 'pending',
  OPERATIONAL: 'operational',
  IN_PROGRESS: 'in-progress',
  PRE_INIT: 'pre-init',
  DEGRADED_PERFORMANCE: 'degraded-performance',
  PARTIAL_OUTAGE: 'partial-outage',
  UNDER_MAINTENANCE: 'under-maintenance',
  MAJOR_OUTAGE: 'major-outage',
} as const

// Institution availability from the /bank-institutions endpoint, mirroring the
// InstitutionStatus proto enum with its INSTITUTION_STATUS_ prefix stripped.
// Keys are lowercase because Chip lowercases before looking a status up.
export const BANK_INSTITUTION_STATUS = {
  UNSPECIFIED: 'unspecified',
  AVAILABLE: 'available',
  DEGRADED: 'degraded',
  DOWN: 'down',
  UNSUPPORTED: 'unsupported',
} as const

export const LOAN_APPLICATION_STATUS = {
  APPROVED: 'approved',
  IN_REVIEW: 'reviewrequired',
  SUBMITTED: 'submitted',
  DISBURSED: 'disbursed',
  CANCELED: 'canceled',
  DRAFT: 'draft',
  REFERRED: 'referred',
  DECLINED: 'declined',
  EXPIRED: 'expired',
  EXPIRED_AGREEMENT: 'expiredagreement',
  PENDING_AGREEMENT: 'pendingagreement',
  PENDING_DISBURSEMENT: 'pendingdisbursement',
  FAILED_DISBURSEMENT: 'faileddisbursement',
} as const

export const RULES_STATUS = {
  PASS: 'pass',
  FAIL: 'fail',
  NOT_APPLICABLE: 'notapplicable',
} as const

export const LOAN_STATUS = {
  OPEN: 'open',
  CLOSED: 'closed',
  PAID_OFF: 'paid_off',
}

export const LOAN_SUBSTATUS = {
  OPEN_REPAYING: 'open_repaying',
  OPEN_FRAUD_PROCESS: 'open_fraud_process',
  OPEN_DECEASED_PROCESS: 'open_deceased_process',
  OPEN_CHARGED_OFF_COLLECTIBLE: 'open_charged_off_collectible',
  OPEN_PENDING_PAYOFF: 'open_pending_payoff',
  OPEN_BANKRUPTCY: 'open_bankruptcy',

  CLOSED_CHARGED_OFF: 'closed_charged_off',
  CLOSED_BANKRUPTCY: 'closed_bankruptcy',

  PAID_IN_FULL: 'paid_in_full',
}

export const LENDING_PLATFORM = 'Lending platform'
export const LOANPRO_BASE_URL = import.meta.env.VITE_LOANPRO_BASE_URL
export const TENANT_ID = import.meta.env.VITE_TENANT_ID
export const LOAN_RECORD_URL_PATH = '/loan/menu/profile'
export const FRANKIE_PORTAL_BASE_URL = import.meta.env.VITE_FRANKIE_PORTAL_BASE_URL
export const ELIGIBILITY_CONSENT_TYPE = 'ELECTRONIC_DOCUMENT'
export const ELIGIBILITY_ACTION = 'REVOKE'

// Fallback for a failed request that carries no message of its own.
export const GENERIC_ERROR_MESSAGE = 'Something went wrong.'

export const ENV_MODES = {
  DEVELOPMENT: 'dev',
  STAGING: 'uat',
  PRODUCTION: 'prod',
}

// Read on each call rather than once at import. A build bakes MODE in either way, but tests stub
// it per test (see src/test/setup.ts), which a value captured at import would never see.
const currentMode = () => import.meta.env.MODE

/** Returns true in dev and UAT builds — use to gate lower-environment-only features. */
export const isLowerEnvironment = (): boolean =>
  currentMode() === ENV_MODES.DEVELOPMENT || currentMode() === ENV_MODES.STAGING

/** Returns true only in the production build. */
export const isProduction = (): boolean => currentMode() === ENV_MODES.PRODUCTION
